export default function AdminPanel() {
  return (
    <div style={{ padding: "40px" }}>
      <h1>ADMIN PANEL</h1>
      <p>Панелът работи.</p>
    </div>
  );
}